import React from "react";
import { Form, Button } from "react-bootstrap";

const LitePlanDetails = (props) => {
  const {t} = props;
  const items = Array.from({ length: 8 }, (_, index) => index+1).map((item,index)=>{
    return(
      <li key={index}>
          <img src="/images/sp-icon.svg" alt=""/>
          <span>{t("free-info-"+item)}</span>
        </li>
    )
  });
    
  

  return (
    <ul>
				{items}
    </ul>
  );
};

export default LitePlanDetails;
